import React from 'react';
import { AutoFocusedForm, Modal, TextField } from 'components';
import { required } from 'components';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  createStyles,
  Divider,
  Grid,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { useUpdateCompanyBalanceForm } from './';
import { Field } from 'react-final-form';
import { MutableButton } from 'ui/MutableButton';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '500px',
    },
    header: {
      fontWeight: 'bolder',
    },
    actions: {
      justifyContent: 'flex-end',
    },
  })
);

export const UpdateCompanyBalancePopup = () => {
  const classes = useStyles();

  const { onCancel, initialValues, onSubmit, loading } = useUpdateCompanyBalanceForm();

  return (
    <Modal
      onClose={onCancel}
      aria-labelledby="Обновление баланса"
      aria-describedby="Используйте эту форму для обновления баланса"
    >
      <AutoFocusedForm
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={({ handleSubmit, pristine }) => {
          return (
            <form onSubmit={handleSubmit}>
              <Card className={classes.root}>
                <CardHeader title="Обновление баланса" />
                <Divider />
                <CardContent>
                  <Grid container spacing={4}>
                    <Grid item lg={12} md={12} xl={12} xs={12}>
                      <Field
                        name="balance"
                        component={TextField}
                        label="Баланс"
                        validate={required}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions className={classes.actions}>
                  <MutableButton
                    loading={loading}
                    color="primary"
                    disabled={pristine}
                    size="medium"
                    type="submit"
                    variant="contained"
                  >
                    Сохранить
                  </MutableButton>
                  <Button
                    onClick={onCancel}
                    disabled={loading}
                    size="medium"
                    type="button"
                    variant="contained"
                  >
                    Отменить
                  </Button>
                </CardActions>
              </Card>
            </form>
          );
        }}
      />
    </Modal>
  );
};
